export const enClientPortalRatingChip = {}
